
namespace TabAurous.HR {

    @Serenity.Decorators.registerClass()
    export class HolidaysEditor extends _Ext.GridEditorBase<HolidaysRow> {
        protected getColumnsKey() { return 'HR.Holidays'; }
        protected getDialogType() { return HolidaysDialog; }
        protected getLocalTextPrefix() { return HolidaysRow.localTextPrefix; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}